export class HigherEducationInstitutionType {
  id: string;
  name: string;
}
